import GaugeContainer from '@components/Battery/GaugeContainer';
import Messages from '@components/Battery/Messages';
import useMakePageScrollable from '@hooks/useMakePageScrollable';

function SYS() {
  useMakePageScrollable();
  return (
    <>
      <GaugeContainer />
      <Messages withTitle />
    </>
  );
}

export default SYS;
